import { forwardRef, type PropsWithChildren } from "react";

import { IconButton, type IconButtonProps } from "./icon-button";

export const SecondaryIconButton = forwardRef<
  HTMLButtonElement,
  PropsWithChildren<Omit<IconButtonProps, "variant">>
>(({ children, ...props }, ref) => {
  return (
    <IconButton ref={ref} variant="secondary" {...props}>
      {children}
    </IconButton>
  );
});
